export default "__VITE_ASSET__BtogO2h1__"